import { getRules, GetRulesArgs } from './requests/get-rules'
import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { Rule } from './shared'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseRulesQueryProps {
  organizationUuid: string
}

export interface RulesQueryResponse {
  rules: Rule[] | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseRulesQuery = (props: UseRulesQueryProps) => RulesQueryResponse

// TODO - don't delete, this one will be used soon
export const useRulesQuery: UseRulesQuery = ({
  organizationUuid
}: UseRulesQueryProps) => {
  const {
    data: rules,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetRulesArgs, Rule[]>(
    [Query.INTEGRATIONS_RULES, organizationUuid],
    getRules,
    {
      organizationUuid
    }
  )

  return {
    rules: rules ? rules.reverse() : undefined,
    error,
    isError,
    isLoading
  }
}
